package com.mgacreative.hotel.feature.finance.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.domain.model.CashMovement
import com.mgacreative.hotel.domain.repository.FinanceRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class CashRegisterViewModel(
    private val financeRepository: FinanceRepository
) : ViewModel() {

    val movements: StateFlow<List<CashMovement>> = financeRepository.observeCashMovements()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )

    init {
        viewModelScope.launch {
            financeRepository.loadCashMovements()
        }
    }

    fun addManualMovement(type: String, amount: Double, description: String, date: String) {
        viewModelScope.launch {
            financeRepository.addCashMovement(type, amount, description, date)
        }
    }
}
